import React, { memo } from "react";
import { Box, Typography, Button } from "@mui/material";

interface FeaturesBannerProps {
  backgroundImage: string;
  onSignUpClick: () => void;
}

const FeaturesBanner = memo(({ backgroundImage, onSignUpClick }: FeaturesBannerProps) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        minHeight: { xs: 350, sm: 400, md: 500 },
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: { xs: "16px", md: "24px" },
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
      }}
    >
      {/* Teal overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "#004B4C",
          opacity: 0.7,
          mixBlendMode: "multiply",
        }}
      />

      {/* Content */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          p: {
            xl: "60px 80px",
            lg: "60px 60px",
            md: "50px 50px",
            sm: "40px 30px",
            xs: "30px 24px",
          },
          maxWidth: { xs: "100%", sm: "80%", md: 800 },
        }}
      >
        <Typography
          variant="h3"
          sx={{
            color: "#ffffff",
            fontWeight: 700,
            // fontStyle: "italic",
            fontSize: { xs: "1.75rem", sm: "2.25rem", md: "2.75rem" },
            lineHeight: 1.2,
            mb: 2.5,
          }}
        >
          Your Home, Smarter & Simpler
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "#ffffff",
            fontSize: { xs: "1rem", md: "1.2rem" },
            lineHeight: 1.3,
            fontWeight: 300,
            mb: 4,
            opacity: 0.95,
            maxWidth: { xs: "100%", sm: "80%", md: 550 },
          }}
        >
          Our platform brings together everything your home needs—management,
          maintenance, and makeovers—so you can enjoy a stress-free and
          well-kept home.
        </Typography>

        <Button
          variant="contained"
          color="secondary"
          size="large"
          onClick={onSignUpClick}
          sx={{
            px: { xs: 5, md: 10, lg: 15 },
            py: { xs: 1.5, md: 2, lg: 2.5 },
            fontSize: { xs: "1rem", md: "1.1rem", lg: "1.2rem" },
            fontWeight: 500,
            borderRadius: "8px",
            textTransform: "none",
            color: "#ffffff",
            mt: 6,
          }}
        >
          Sign Up Now!
        </Button>
      </Box>
    </Box>
  );
});

export default FeaturesBanner;
